<template>
  <div>
    <yandex-map :coords="coords" @click="onClick" :zoom="12" :scroll-zoom="false">
      <ymap-marker 
        marker-id="123" 
        :coords="coords"
        :balloon-template="balloonTemplate"
        :icon="markerIcon"
      ></ymap-marker>
    </yandex-map>
  </div>
</template>

<script>
export default {
  data: () => ({
    coords: [55.53805200761735, 28.786684033430944], 
     markerIcon: {
      layout: 'default#imageWithContent',
      imageHref: 'https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/logo%2FShelterLogoMap.png?alt=media&token=a3056403-cb07-4e47-848d-92226aa29684',
      imageSize: [43, 43],
      imageOffset: [-10, -20],
      // content: '123 v12',
      // contentOffset: [0, 0],
      // contentLayout: '<div style="background: red; width: 50px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
    }
  }),
  computed: {
    balloonTemplate() {
      return `
        <h1 class="green">Приют для животных в Полоцке!</h1>
        <p>Координаты GPS: ${this.coords}</p>
        <img src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/images%2F2NzhhVJQxfM.jpgZYKcLst8DuiWgR6BrkTK?alt=media&token=ebcb00be-eb1f-4a95-be2f-cb98b66b63ba">
      `
    }
  },
  methods: {
    onClick(e) {
      this.coords = e.get('coords');
    }
  }  
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.ymap-container {
  height: 600px;
}
.green {
  color: green;
}
</style>